export default __webpack_public_path__ + "static/media/Printemps.5d8808f8.png";